import "./ProfileAndHistoryZonePP2.module.css";
import Header from "@/reusable_sections/Header";
import ZonaPPProfilHero from "./sections/ZonaPPProfilHero";
import OrganizationProfile from "./sections/OrganizationProfile";
import Footer from "@/reusable_sections/Footer";
export default function ProfileAndHistoryZonePP2Page() {
  return <div>
      <Header />
      <ZonaPPProfilHero />
      <OrganizationProfile />
      <Footer />
    </div>;
}